import { useState, ChangeEvent } from 'react';
import { Link } from 'react-router-dom';
import {
  Eventswebinars,
  EventsWebinarFigure,
  InflationEventsWebinars,
  InflationSignUp,
  CompoundInterestConstancy,
  SuperPowerCards,
  OurSpeakrs,
  OurSpeakrsCardCont,
  OurSpeakrsCard,
  OurSponsors
} from './eventsWebinars.styles';
import { Banner } from 'src/utilities/UILibrary/Media/Banner/Banner';

export default function EventsWebinars() {
  const [userData, setUserData] = useState({});

  const handleEmail = (e: ChangeEvent<HTMLInputElement>) => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (re.test(String(e.target.value).toLowerCase()) === true) {
      setUserData({ ...userData, [e.target.name]: e.target.value });
    } else {
      setUserData({ ...userData, [e.target.name]: undefined });
    }
  };

  function handleChange() {
    return;
  }

  const sendDataToServer = () => {
    return;
  };

  return (
    <Eventswebinars>
      <Banner imgSrc={`${process.env.REACT_APP_BUCKET_FINSPHERA}/img_eventsWebinars.jpg`}>
        <h1>
          1er Summit online de
          <span> Salud y Libertad Financiera</span>
        </h1>
        <p> powered by Finsphera.</p>
      </Banner>
      <EventsWebinarFigure>
        <div>
          <figure>
            <img
              src={`${process.env.REACT_APP_BUCKET_FINSPHERA}/iconCalendar.png`}
              alt="Vector 1"
            />
          </figure>
          <p>Jueves 19 de Octubre de 2023</p>
        </div>
        <div></div>
        <div>
          <figure>
            <img src={`${process.env.REACT_APP_BUCKET_FINSPHERA}/iconTimer.png`} alt="Vector 2" />
          </figure>
          <p>9 am a 2 pm GMT-5</p>
        </div>
        <div></div>
        <div>
          <figure>
            <img src={`${process.env.REACT_APP_BUCKET_FINSPHERA}/iconTicket.png`} alt="Vector 3" />
          </figure>
          <p>Entrada Libre</p>
        </div>
      </EventsWebinarFigure>
      <InflationEventsWebinars>
        <div>
          <h2>La inflación</h2>
          <p>
            ¡Es nuestro enemigo silencioso! Cada día que pasa nuestro dinero puede comprar menos
            productos y servicios como consecuencia de la inflación.
          </p>
          <p>Pero, absolutamente todos podemos utilizar nuestros 2 superpoderes:</p>
          <h2>El Interés Compuesto</h2>
          <p>
            Invierte $1,000 al mes y con un rendimiento anual del 15% el Interés Compuesto
            convertirá tu dinero en 10 años en $278 Mil, en 15 años en $676 Mil y en 20 años en
            $1,515,000.
          </p>
          <h2>La Constancia</h2>
          <p>¡Al invertir y reinvertir las ganancias nuestro dinero crece exponencialmente!</p>
        </div>
        <div>
          <div>
            <h2>¡Regístrate gratis!</h2>
            <p>Nombre:</p>
            <input onChange={handleChange} name="name" type="text" />
            <p>Correo electrónico:</p>
            <input onChange={handleEmail} name="email" type="email" />
            <div>
              <input type="checkbox" name="isAcceptTerms" />
              <p>
                He leido y estoy de acuerdo con los términos y condiciones y politicas de privacidad
                del sitio.
              </p>
            </div>
            <InflationSignUp>
              <button onClick={sendDataToServer}>Registrarme ahora</button>
              <Link to="#" target="_blank">
                Descarga el folleto del evento
              </Link>
            </InflationSignUp>
          </div>
        </div>
      </InflationEventsWebinars>
      <CompoundInterestConstancy>
        <h2>Interés Compuesto + Constancia = Salud y Libertad Financiera</h2>
        <p>¡En este Summit te enseñamos cómo utilizar tus Superpoderes!</p>
        <SuperPowerCards>
          <div>
            <h5>Educación Financiera</h5>
            <p>
              Aprende a utilizar los servicios financieros para cumplir con tus objetivos a corto,
              median y largo plazo. ¡No les tengas miedo y aumenta tus capacidades financieras!
            </p>
          </div>
          <div>
            <h5>Inclusión Financiera</h5>
            <p>
              Ahora que ya sabes como utilizar los servicios financieros, contrata los que más te
              convengan.
            </p>
          </div>
          <div>
            <h5>Salud y Libertad Financiera</h5>
            <p>
              Distruta de los beneficios de las Inversiones para que estés protegido en caso de una
              emergencia. ¡Invierte para pagar tus estudios o una casa y disfruta de tu jubilación
              viajando!
            </p>
          </div>
        </SuperPowerCards>
      </CompoundInterestConstancy>
      <OurSpeakrs>
        <h2>Nuestros Conferencistas</h2>
        <OurSpeakrsCardCont>
          <OurSpeakrsCard>
            <div>
              <figure>
                <img
                  src="https://finsphera-webapp-resources.s3.amazonaws.com/icon_user.png"
                  alt="Imagen conferencista"
                />
              </figure>
            </div>
            <div>
              <h3></h3>
              <p>CEO</p>
              <figure>
                <img
                  src="https://finsphera-webapp-resources.s3.amazonaws.com/icon_questionMarks.png"
                  alt=""
                />
              </figure>
              <Link to="#">
                <figure>
                  <img
                    src="https://finsphera-webapp-resources.s3.amazonaws.com/icon_LinkedinGreen.png"
                    alt=""
                  />
                </figure>
              </Link>
            </div>
          </OurSpeakrsCard>
          <OurSpeakrsCard>
            <div>
              <figure>
                <img
                  src="https://finsphera-webapp-resources.s3.amazonaws.com/icon_user.png"
                  alt="Imagen conferencista"
                />
              </figure>
            </div>
            <div>
              <h3></h3>
              <p>CEO</p>
              <figure>
                <img
                  src="https://finsphera-webapp-resources.s3.amazonaws.com/icon_questionMarks.png"
                  alt=""
                />
              </figure>
              <Link to="#">
                <figure>
                  <img
                    src="https://finsphera-webapp-resources.s3.amazonaws.com/icon_LinkedinGreen.png"
                    alt=""
                  />
                </figure>
              </Link>
            </div>
          </OurSpeakrsCard>
          <OurSpeakrsCard>
            <div>
              <figure>
                <img
                  src="https://finsphera-webapp-resources.s3.amazonaws.com/image_AlbertoRatia.png"
                  alt="Imagen conferencista"
                />
              </figure>
            </div>
            <div>
              <h3>Alberto Ratia</h3>
              <p>Co-Fundador</p>
              <figure>
                <img
                  src="https://finsphera-webapp-resources.s3.amazonaws.com/image_Finspherawebinars.png"
                  alt=""
                />
              </figure>
              <Link to="/">
                <figure>
                  <img
                    src="https://finsphera-webapp-resources.s3.amazonaws.com/icon_LinkedinGreen.png"
                    alt=""
                  />
                </figure>
              </Link>
            </div>
          </OurSpeakrsCard>
        </OurSpeakrsCardCont>
      </OurSpeakrs>
      <OurSponsors>
        <h2>Nuestros patrocinadores</h2>
        <div>
          <Link to="http://www.afico.org/" target={'_blank'} rel="noreferrer">
            <figure>
              <img
                src="https://finsphera-webapp-resources.s3.amazonaws.com/icon_home_aliados_afico.png"
                alt="Finsphera aliado AII"
              />
            </figure>
          </Link>
          <Link to="https://aiimx.com.mx/" target={'_blank'} rel="noreferrer">
            <figure>
              <img
                src="https://finsphera-webapp-resources.s3.amazonaws.com/OurPartnersAii.png"
                alt="Finsphera aliado CCMX"
              />
            </figure>
          </Link>
          <Link to="https://www.pactomundial.org.mx/" target={'_blank'} rel="noreferrer">
            <figure>
              <img
                src="https://finsphera-webapp-resources.s3.amazonaws.com/OurPartnersPactoGlobal.png"
                alt="Finsphera aliado L & C A"
              />
            </figure>
          </Link>
          <Link to="https://fintechu.mx/" target={'_blank'} rel="noreferrer">
            <figure>
              <img
                src="https://finsphera-webapp-resources.s3.amazonaws.com/OurPartnersFintech.png"
                alt="Finsphera aliado BIOFIN"
              />
            </figure>
          </Link>
          <Link to="https://mujeresenfinanzas.mx/" target={'_blank'} rel="noreferrer">
            <figure>
              <img
                src="https://finsphera-webapp-resources.s3.amazonaws.com/OurPartnersMef.jpg"
                alt="Finsphera aliado PNUD"
              />
            </figure>
          </Link>
          <Link
            to="https://www.unglobalcompact.org/take-action/target-gender-equality"
            target={'_blank'}
            rel="noreferrer"
          >
            <figure>
              <img
                src="https://finsphera-webapp-resources.s3.amazonaws.com/icon_home_genderEquality.jpg"
                alt="Finsphera aliado AFICO"
              />
            </figure>
          </Link>
        </div>
      </OurSponsors>
    </Eventswebinars>
  );
}
